let standard_years = [];
let this_year = new Date().getFullYear();
let this_year_string = this_year + '';
standard_years.push({ year: this_year_string });

for(let i = 1; i < 25; i++){
    let year_to_string = this_year - i + '';
    standard_years.push({ year: year_to_string });
}
export default standard_years;
